<template>
  <v-layout justify-center>
    <div>
      <v-layout>
        <v-flex xs12 md4 offset-md4 class="text-sm-center">
          <span class="headline">BOOTHS</span>
        </v-flex>
      </v-layout>

      <v-flex xs12>
        <vue-good-table
          ref="my-table"
          styleClass="vgt-table striped bordered"
          :max-height=this.height
          :fixed-header="true"
          :isLoading=this.isTableLoading
          :columns="columns"
          :rows="rows"
          :search-options="{
            enabled: true
          }">
          <template slot="loadingContent">
            <div>
              <v-progress-circular
                :size="50"
                :width="7"
                color="blue"
                indeterminate
              ></v-progress-circular>
            </div>
          </template>
          <div slot="table-actions-bottom">
            <span class="body-2" style="padding-left: 20px;">Number of records: {{ totalCount }}</span>
          </div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'area'">
              <v-layout align-center justify-start row fill-height>
                <v-flex xs12>
                  {{ props.row.area }} sqft
                </v-flex>
              </v-layout>
            </span>
            <span v-else-if="props.column.field == 'actions'">
              <div class="text-xs-center">
                <v-avatar
                  color="blue lighten-4"
                  class="mr-2 mt-2"
                  size="30"
                  style="cursor: pointer;"
                  @click="editItem(props)"
                >
                  <v-icon small>edit</v-icon>
                </v-avatar>
              </div>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </v-flex>

      <v-btn
        fab
        bottom
        right
        color="blue"
        dark
        fixed
        class="add-button-bottom"
        @click="dialog = !dialog"
      >
        <v-icon>add</v-icon>
      </v-btn>

      <v-dialog v-model="dialog" max-width="500px">
        <v-card >
          <v-toolbar card dark color="primary">
            <v-btn icon dark @click="close">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Add/Edit Booth</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <!-- <v-btn v-if="edit" dark flat @click="updateItem">Udate</v-btn> -->
              <v-btn dark flat @click="save">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout class="pb-3" row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="evalItem.boothNumber"
                    @keyup.enter="save"
                    label="Booth Number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="evalItem.size"
                    @keyup.enter="save"
                    label="Size"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="evalItem.area"
                    @keyup.enter="save"
                    label="Area (SqFt)"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :multi-line=true
        :timeout="6000"
      >
        {{ snackbar.message }}
        <v-btn
          dark
          flat
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </v-snackbar>
      </div>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import XLSX from 'xlsx'

export default {
  props: ['visible', 'currentYear'],

  components: {
    VueGoodTable
  },
  data () {
    return {
      myId: this.$store.state.user.id,
      page: 'booth',
      dialog: false,
      loading: false,
      isTableLoading: false,
      isMounted: false,
      toggle_multiple: ['chair', 'assist', 'excel'],
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      height: 0,
      columns: [
        {
          label: 'Booth(s)',
          field: 'boothNumber',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'text-center',
          type: 'text'
        },
        {
          label: 'Name',
          field: 'name',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Contact',
          field: 'contact',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Size',
          field: 'size',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Area',
          field: 'area',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Location',
          field: 'location',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Edit',
          field: 'actions',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false,
          hidden: false,
          html: true,
          width: '60px'
        }
      ],
      committeeHeader: {},
      rows: [],
      evalItem: {}
    }
  },

  created () {
    this.isCommChair = false
    this.isTableLoading = true

    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getMembers()
    this.getBooths()

    this.loading = false
    // console.log(this.$refs)
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    selected () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].selectedRowCount > 0
    },

    totalCount () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].totalRowCount
    }
  },

  watch: {
    currentYear: {
      handler: function (val, oldVal) {
        this.getBooths()
      },
      deep: true
    }
  },

  methods: {
    async getMembers () {
      let allUsers = 'users'

      try {
        const response = await Api().get(allUsers)
        this.memberList = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    handleResize () {
      const height = window.innerHeight - 360
      this.height = height + 'px'
    },

    newItem () {
      this.dialog = true
    },

    editItem (props) {
      this.evalItem = props.row

      this.dialog = true
    },

    async save () {
      if (this.evalItem.id > 0) {
        this.edit()
      } else {
        this.add()
      }
    },

    async add () {
      const result = this.rows.find(({ boothNumber }) => boothNumber === Number(this.evalItem.boothNumber))

      if (result) {
        this.snackbar.message = 'The booth number ' + this.evalItem.boothNumber + ' is already assigned!'
        this.snackbar.color = 'error'
        this.snackbar.show = true
      } else {
        try {
          this.evalItem.year = this.currentYear
          this.evalItem.location = 'Vendor Alley'

          const response = await Api().post('vendor_booths', this.evalItem)

          this.getBooths()
          this.evalItem = {}
          this.dialog = false

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    async edit () {
      try {
        const response = await Api().put('vendor_booths/' + this.evalItem.id, this.evalItem)

        this.evalItem = {}
        this.dialog = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getBooths () {
      this.isCommChair = false

      try {
        const response = await Api().get('booths/' + this.currentYear)

        const booths = response.data

        for (let i in booths) {
          let name = ''
          let rep = ''
          if (booths[i].VendorCompany) {
            let vendor = booths[i].VendorCompany
            name = vendor.name

            if (vendor.VendorContacts[0]) {
              let user = vendor.VendorContacts[0]
              rep = user.firstName + ' ' + user.lastName
            }
          }
          booths[i].name = name
          booths[i].contact = rep
        }

        console.log(this.currentYear, booths)

        this.rows = response.data

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    onExport () {
      this.printMembers = this.rows.map(a => ({
        'Name': a.name,
        'Address': a.address,
        'City': a.city,
        'State': a.state,
        'Zip': a.zip,
        'Primary Phone': a.primaryPhone,
        'Secondayr Phone': a.secondaryPhone,
        'Email': a.email,
        'Age': a.age,
        'Height': a.height,
        'Weight': a.weight,
        'Parents': a.parents,
        'Notes': a.notes
      }))

      let membersWS = XLSX.utils.json_to_sheet(this.printMembers)

      let wb = XLSX.utils.book_new()

      if (!wb.Props) { wb.Props = {} }
      wb.Props.Title = 'Insert Title Here'

      XLSX.utils.book_append_sheet(wb, membersWS, this.committeeHeader.committeeCode)

      XLSX.writeFile(wb, this.currentYear + ' Mutton Busters.xlsx')
    },

    close () {
      this.evalItem = {}
      this.dialog = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}
</style>



// WEBPACK FOOTER //
// src/components/vendor/Booths.vue